// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modalContainer-3RHG2","modalHeader":"modalHeader-2uUW8","modalBody":"modalBody-3bToV","confirmButton":"confirmButton-1hiVK","loader":"loader-1l3ix"};